export const aawzDrive =
  (state) =>
  (rootKey = 'default') => {
    const data = state.aawzDrive.data || {}
    const key =
      rootKey !== null && rootKey !== undefined ? String(rootKey) : 'default'
    return data[key] || null
  }

export const aawzDriveLoading = (state) => {
  return state.aawzDrive.loading
}

export const aawzDriveUploadLoading = (state) => {
  return state.aawzDrive.uploadLoading
}

export const aawzDriveLastUpdate = (state) => {
  return state.aawzDrive.lastUpdate
}

export const aawzDriveAllowedExtensions = (state) => {
  return state.aawzDrive.allowedExtensions
}
